module.exports = __webpack_public_path__ + "static/media/chinmay_dixit.0dc615f7.jpg";